<template lang="pug">
    article#jornadaDeExtensao
        Banner(@jasoualuno="aside = true")
        Aside(:ativo="aside", @close="aside = false")
        Juntos
        FormInscricao(titulo="Cadastre-se Gratuitamente", subtitulo="")
</template>

<script>
import Banner from '@sections/JornadaDeExtensao/Banner/Banner.vue'
import Aside from '@sections/JornadaDeExtensao/Aside/Aside.vue'
import Juntos from '@sections/JornadaDeExtensao/Juntos/Juntos.vue'
import FormInscricao from '@components/Inscricao/Inscricao'
import pagina from '@/mixins/pagina'

export default {
    name: "view-jornada-de-extensao",
    components: {
        Banner,
        Aside,
        Juntos,
        FormInscricao
    },
    data() {
        return {
            aside: false
        }
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./JornadaDeExtensao.styl"></style>